import { pageState, matchRouteName } from '@helpers/page-state';
import { redirectTo } from '@helpers/url-handler';
import { objectMap } from '@helpers/helpers';
import axios from 'axios';
import Cookies from 'js-cookie';

const state = (matchRouteName('create-advert') || matchRouteName('edit-advert') || matchRouteName('admin.adverts.edit')) && {
    pageState,
    currentStep: 1,
    stepCompletion: {
        1: {
            isCompleted: false,
            isCollapsed: false,
            canViewEdit: false,
        },
        2: {
            isCompleted: false,
            isCollapsed: true,
            canViewEdit: false,
        },
        3: {
            isCompleted: false,
            isCollapsed: true,
            canViewEdit: false,
        },
        4: {
            isCompleted: false,
            isCollapsed: true,
            canViewEdit: false,
        },
        5: {
            isCompleted: false,
            isCollapsed: true,
            canViewEdit: false,
        },
    },
    stepsData: {},
    wantPropertyType: null,
    isEditing: pageState.hasOwnProperty('adData'),
    isLoading: false,
};

const actions = {
    async changeStepView({ state, commit }, payload) {
        await commit('setCurrentStep', payload);
        objectMap(state.stepCompletion, (obj, step) => {
            commit('setStepCompletion', {
                step,
                isCollapsed: parseFloat(step) !== state.currentStep,
                canViewEdit: parseFloat(step) < state.currentStep,
            });
        });
    },
    async changeStep({ state, commit, dispatch }, payload) {
        commit('setIsLoading', true);
        const [nextStep, stepData] = payload;

        const newStepsData = stepData;
        newStepsData.step = state.currentStep;
        if (state.isEditing) {
            newStepsData.uuid = state.pageState.adData.uuid;
        }
        await commit('mergeStepsData', newStepsData);

        axios.post(`/api/advert/save/${state.pageState.adType.slug}`, state.stepsData)
            .then(async ({ status, data }) => {
                await dispatch('changeStepView', nextStep);
                objectMap(state.stepCompletion, (obj, step) => {
                    commit('setStepCompletion', {
                        step,
                        isCompleted: parseFloat(step) < state.currentStep || obj.isCompleted,
                    });
                });
                if (status === 200) {
                    const advert = data.data;
                    if (!advert.has_owner) {
                        Cookies.set('krispy_created_slug', advert.slug, { expires: 1 });
                    }
                    if (window.appInProduction) {
                        window.gtag('event', 'create_ad', {
                            adType: advert.ad_type,
                        });
                    }
                    if (matchRouteName('admin.adverts.edit')) {
                        redirectTo('/admin/adverts');
                    } else {
                        redirectTo(`/preview/${advert.slug}`);
                    }
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 403) {
                    if (error.response.data.message.search('cannot_post_advert_type') !== -1) {
                        const message = error.response.data.message.replace('cannot_post_advert_type ', '');
                        window.showError('Can\'t post advert type', message);
                    }
                }
            })
            .finally(() => {
                // scroll to current step
                const els = document.getElementsByClassName('step');
                Array.from(els).some((el) => {
                    if (!el.hasAttribute('collapsed')) {
                        window.scroll({
                            top: el.offsetTop - 60,
                            left: 0,
                            behavior: 'smooth',
                        });
                        return true;
                    }
                    return false;
                });
                commit('setIsLoading', false);
            });
    },
};

const mutations = {
    setStepCompletion(state, payload) {
        const {
            step, isCompleted, isCollapsed, canViewEdit,
        } = payload;
        if (typeof isCompleted === 'boolean') {
            state.stepCompletion[step].isCompleted = isCompleted;
        }
        if (typeof isCollapsed === 'boolean') {
            state.stepCompletion[step].isCollapsed = isCollapsed;
        }
        if (typeof canViewEdit === 'boolean') {
            state.stepCompletion[step].canViewEdit = canViewEdit;
        }
    },
    setIsLoading(state, payload) {
        state.isLoading = payload;
    },
    setCurrentStep(state, payload) {
        state.currentStep = payload;
    },
    setWantPropertyType(state, payload) {
        state.wantPropertyType = payload;
    },
    mergeStepsData(state, payload) {
        Object.assign(state.stepsData, payload);
    },
};

const getters = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
